import { TFunction } from 'next-i18next';
import {
  BackendItems,
  BlockchainItems,
  DigitalDesignItems,
  FrontendItems,
  InfrastructureItems,
  MobileItems,
  ReportAndCommunicationItems,
  TestingQAItems,
} from './tools';

export enum TECH_STACK_ENUM {
  DIGITAL_DESIGN = 'digital-design',
  FRONT_END = 'front-end',
  BACK_END = 'back-end',
  MOBILE = 'mobile',
  BLOCKCHAIN = 'blockchain',
  INFRASTRUCTURE = 'infrastructure',
  TESTING_QA = 'testing-qa',
  REPORT_AND_COMMUNICATION = 'report-and-communication',
  GAME_ENGINEERS = 'game-engineers',
}

export interface Stack {
  url: string;
  alt: string;
}

export const itemDedicatedDevelopmentBreadcrumbs = (t: TFunction) => [
  {
    name: t('common.home'),
    path: '/',
  },
  {
    name: t('common.services'),
    path: '/services',
  },
  {
    name: t('dedicated_development.dedicated_development_team_service'),
    path: '/services/dedicated-development-team',
  },
];

export const expertsItems = [
  {
    title: 'dedicated_development.project_managers',
    description: 'dedicated_development.to_oversee_the_planning',
    icon: '/icons/services/project-managers-icon.svg',
  },
  {
    title: 'dedicated_development.ux_ui_designers',
    description: 'dedicated_development.to_create_a_visually',
    icon: '/icons/services/ux.ui-designers-icon.svg',
  },
  {
    title: 'dedicated_development.frontend_developers',
    description: 'dedicated_development.to_turn_design_to',
    icon: '/icons/services/frontend-developers-icon.svg',
  },
  {
    title: 'dedicated_development.backend_developers',
    description: 'dedicated_development.to_take_care_of',
    icon: '/icons/services/backend-developers-icon.svg',
  },
  {
    title: 'staff_augmentation.devops_engineers',
    description: 'dedicated_development.to_ensure_that',
    icon: '/icons/services/devops-engineer-icon.svg',
  },
  {
    title: 'dedicated_development.qa_specialists',
    description: 'dedicated_development.to_accompany_the_team',
    icon: '/icons/services/qa-speciallists-icon.svg',
  },
];

export const dedicatedItems = (t: TFunction) => [
  {
    title: t('dedicated_development.guaranteed_technical'),
    describe: t('dedicated_development.80_percent_of_our_forces'),
  },
  {
    title: t('dedicated_development.reliable_flexible_scalable'),
    describe: t('dedicated_development.have_all_resources_ready'),
  },
  {
    title: t('dedicated_development.security_and_management'),
    describe: t('dedicated_development.our_iso_certified'),
  },
  {
    title: t('dedicated_development.time_and_cost_significantly'),
    describe: t('dedicated_development.no_more_headaches_over'),
  },
];

export const ourDedicatedProcess = (t: TFunction) => [
  {
    title: t('dedicated_development.discovery'),
    content: t('service.we_discuss_with_you_the_target'),
  },
  {
    title: t('dedicated_development.ideation'),
    content: t('service.our_expert_team_gathers_to_define'),
  },
  {
    title: t('dedicated_development.talent_matching'),
    content: t('service.we_nominate_our_dedicated'),
  },
  {
    title: t('dedicated_development.onboarding'),
    content: t('service.we_integrate_with_your_inhouse_team'),
  },
  {
    title: t('dedicated_development.development'),
    content: t('service.we_split_the_development_cycle'),
  },
  // {
  //   title: t('dedicated_development.final_delivery'),
  //   content: t('service.we_finish_all_scopes'),
  // },
];

export const takeCareItems = [
  {
    title: 'dedicated_development.what_you_do',
    descriptionList: [
      'dedicated_development.provide_the_technical',
      'dedicated_development.define_the_project_requirements',
      'dedicated_development.actively_participate',
      'dedicated_development.review_and_approve',
    ],
    icon: '/icons/check-icon-version1.svg',
  },
  {
    title: 'dedicated_development.what_we_do',
    descriptionList: [
      'dedicated_development.provide_talents_that',
      'dedicated_development.prepare_the_project',
      'dedicated_development.report_and_communicate',
      'dedicated_development.provide_post_launch_support',
    ],
    icon: '/icons/check-icon-version2.svg',
  },
];

export const recognizedItems = (t: TFunction) => [
  {
    image: '/images/about/ISO-27001-2013.webp',
    alt: 'Certified Company - ISO[27001:2013]',
    content: t('about-us.txtISO'),
    link: '',
  },
  {
    image: '/images/about/ISO-9001-20150.webp',
    alt: 'Certified Company - ISO[9001:2015]',
    content: t('about-us.iso_9001'),
    link: '',
  },
  {
    image: '/images/about/top-b2b-companies.webp',
    alt: t('about-us.txtB2b'),
    content: t('home.txtClutchLogo'),
    link: '',
  },
  {
    image: '/images/about/app-futa.webp',
    alt: t('about-us.txtB2b'),
    content: t('common.txtAppfutas'),
    link: '',
  },
  {
    image: '/images/about/goodfirm-award.webp',
    alt: 'Goodfirm awards',
    content: t('common.txtBestGood'),
    link: 'https://www.goodfirms.co/company/ekotek',
  },
  {
    image: '/images/about/logo-bronze.webp',
    alt: 'Token Vesting Portal Fintech Solution',
    content: t('home.txtStevieLogo'),
    link: '',
  },
  {
    image: '/images/about/logo-top-blockchain.webp',
    alt: t('about-us.txtTopBlockChain'),
    content: t('home.txtGoodFirmLogo'),
    link: 'https://www.goodfirms.co/company/ekotek',
  },
  {
    image: '/images/about/logo-software.webp',
    alt: 'software developers vietnam',
    content: t('home.txtSofwareLogo'),
    link: '',
  },
  {
    image: '/images/about/top-b2b-services.webp',
    alt: t('about-us.txtB2b'),
    content: t('home.txtClutchLogo'),
    link: '',
  },
  // {
  //   image: '/images/about/logo-bga.webp',
  //   alt: t('about-us.txtJAB'),
  //   content: t('home.txtBGALogo'),
  //   link: '',
  // },
  {
    image: '/images/about/logo-tech-review.webp',
    alt: 'Techreviewer',
    content: t('home.txtTechReviewLogo'),
    link: '',
  },
  {
    image: '/images/about/top-mobile-app.webp',
    alt: t('about-us.txtTopMobile'),
    content: t('home.txtGoodFirmLogo'),
    link: 'https://www.goodfirms.co/company/ekotek',
  },
];

export const techStackItems = [
  {
    label: 'dedicated_development.digital_design',
    key: TECH_STACK_ENUM.DIGITAL_DESIGN,
    child: DigitalDesignItems,
  },
  {
    label: 'dedicated_development.frontend',
    key: TECH_STACK_ENUM.FRONT_END,
    child: FrontendItems,
  },
  {
    label: 'dedicated_development.backend',
    key: TECH_STACK_ENUM.BACK_END,
    child: BackendItems,
  },
  {
    label: 'dedicated_development.mobile',
    key: TECH_STACK_ENUM.MOBILE,
    child: MobileItems,
  },
  {
    label: 'dedicated_development.blockchain',
    key: TECH_STACK_ENUM.BLOCKCHAIN,
    child: BlockchainItems,
  },
  {
    label: 'dedicated_development.infrastructure',
    key: TECH_STACK_ENUM.INFRASTRUCTURE,
    child: InfrastructureItems,
  },
  {
    label: 'dedicated_development.testing_qa',
    key: TECH_STACK_ENUM.TESTING_QA,
    child: TestingQAItems,
  },
  {
    label: 'dedicated_development.report_communication',
    key: TECH_STACK_ENUM.REPORT_AND_COMMUNICATION,
    child: ReportAndCommunicationItems,
  },
];

export const faqDedicatedDevelopmentTeam = (t: TFunction) => [
  {
    question: t('dedicated_development.w_is_a_dedicated_development_team'),
    answer: t('dedicated_development.a_dedicated_software'),
  },
  {
    question: t('dedicated_development.w_are_differences_between'),
    answer: t('dedicated_development.an_inhouse_software'),
  },
  {
    question: t('dedicated_development.w_types_of_projects'),
    answer: t('dedicated_development.dedicated_teams_can_be'),
  },
  {
    question: t('dedicated_development.w_are_the_benefits'),
    answer: t('dedicated_development.one_major_benefit_of_using'),
  },
  {
    question: t('dedicated_development.w_is_the_price'),
    answer: t('dedicated_development.the_price_of_ekotek'),
  },
];
